module.exports = __webpack_public_path__ + "img/terracenew_box07.ca6d1a2a.jpg";